// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-MCZe","content":"styles_content__3SknG"};